import { STRING_MAP } from "./base";

export const localize = (key, params) => {
  let res = key && STRING_MAP[key] ? STRING_MAP[key] : (key || "").replaceAll("_", " ");
  if (params) {
    Object.keys(params).forEach((param) => {
      res = res.replaceAll(`{{${param}}}`, localize(params[param]));
    });
  }
  return res;
};
